/* A small "Live" cue for pages whose status dots are pushed over SSE.

   It only claims to be live when the stream is actually up: connected → a
   breathing mint dot and "Live"; momentarily dropped or backgrounded → a still
   grey dot and "Reconnecting…". When the backend has no live-status channel at
   all (AMI off) it renders nothing, so the page doesn't promise something it
   can't deliver. */
export default function LiveIndicator({ connected, supported = true }) {
  if (!supported) return null;

  return (
    <span
      style={{ display: 'inline-flex', alignItems: 'center', gap: 7, fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--ink-soft)' }}
      title={connected ? 'Status is updating live' : 'Reconnecting to live status…'}
    >
      <span className={connected ? 'live-dot' : 'live-dot live-dot--idle'} />
      {connected ? 'Live' : 'Reconnecting…'}
    </span>
  );
}
